import { withInstall } from '@vuesax-plus/utils'
import Teleport from './src/teleport.vue'

export const VsTeleport = withInstall(Teleport)

export default VsTeleport

export * from './src/teleport'
